module.exports = __webpack_public_path__ + "assets/img/27_1256.65d35973.jpg";